// @flow

import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { css } from 'glamor';

const color = 'rgb(51, 51, 51)';
const selectedColor = 'rgb(228, 65, 34)';

const letterRule = css({
    fontWeight: 600,
    fontSize: '1.4em',
    textTransform: 'uppercase',
});

const linkRule = css({
    color: color,
    textDecoration: 'none',
    transition: 'color 0.3s ease',

    '&:hover': {
        color: selectedColor,
    },
});

const selectedLetterRule = css({
    color: selectedColor,
    textDecoration: 'underline',
});

@observer
export default class SearchLetter extends Component {
    props: {
        letter: string,
        handleClick: () => void,
        selected: boolean,
    };

    render() {
        const { letter, handleClick, selected } = this.props;
        const rule = selected ? selectedLetterRule : null;

        return (
            <span { ...letterRule }>
                <a role="button" onClick={ handleClick } { ...linkRule } { ...rule }>
                    {letter}
                </a>
            </span>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/global/SearchLetter/index.js